export default __webpack_public_path__ + "static/media/admin-signin.71a6fd76.jpg";